export default __webpack_public_path__ + "static/media/kheng-videos2.ae808a5f.jpg";